// src/documentTypes.js
export const documentTypes = [
    { value: "PASSPORT", label: "Passport" },
    { value: "ID_CARD", label: "Identification Card" },
    { value: "CERTIFICATE", label: "Certificate" },
    { value: "LICENSE", label: "Driver's License (Generic)" },
    { value: "OTHER", label: "Other" },
    { value: "RESUME", label: "Resume" },
    { value: "CV", label: "Curriculum Vitae" },
    { value: "REFERENCES", label: "References" },
    { value: "CERTIFICATE_OF_IDENTITY", label: "Certificate of Identity (AUS)" },
    { value: "PHOTO_ID_CARD", label: "Photo ID Card (AUS Regulatory)" },
    { value: "FOREIGN_DOCUMENT", label: "Foreign Document (Equivalent)" },
    { value: "FOREIGN_PASSPORT", label: "Foreign Passport (Current)" },
    { value: "INDIGENOUS_ORGANISATION_REFERENCE", label: "Indigenous Organisation Reference" },
    { value: "UTILITY_BILL", label: "Utility Bill" },
    { value: "RATING_AUTHORITY_NOTICE", label: "Rating Authority Notice" },
    { value: "CITIZENSHIP_CERTIFICATE", label: "Australian Citizenship Certificate" },
    { value: "FULL_BIRTH_CERTIFICATE", label: "Full Birth Certificate" },
    { value: "DRIVER_LICENSE_AUS", label: "Australian Driver Licence" },
    { value: "TERTIARY_STUDENT_ID_CARD", label: "Tertiary Student ID Card" },
    { value: "DEFENCE_ID_CARD", label: "Defence Force Identity Card" },
    { value: "GOVERNMENT_EMPLOYEE_ID", label: "Government Employee ID" },
    { value: "DVA_CARD", label: "DVA Card" },
    { value: "CENTRELINK_CARD", label: "Centrelink Card" },
    { value: "MARRIAGE_CERTIFICATE", label: "Marriage Certificate" },
    { value: "DECREE_NISI_ABSOLUTE", label: "Decree Nisi/Absolute" },
    { value: "CHANGE_OF_NAME_CERTIFICATE", label: "Change of Name Certificate" },
    { value: "BANK_STATEMENT", label: "Bank Statement" },
    { value: "LEASE_AGREEMENT", label: "Lease Agreement" },
    { value: "TAXATION_NOTICE", label: "Taxation Assessment Notice" },
    { value: "MORTGAGE_DOCUMENTS", label: "Mortgage Documents" },
    { value: "BIRTH_CARD", label: "Birth Card" },
    { value: "AUSTRALIAN_PASSPORT", label: "Australian Passport" },
    { value: "BIRTH_CERTIFICATE_EXTRACT", label: "Birth Certificate Extract" },
    { value: "MEDICARE_CARD", label: "Medicare Card" },
    { value: "CREDIT_OR_ACCOUNT_CARD", label: "Credit or Account Card" },
];